import {
  Card,
  DropDown,
  Button,
  ModalEditBox,
  ModalPopup,
  LanguageSelector,
  LocalisedFieldIndicator
} from "../components/index";
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component("drop-down", DropDown);
    Vue.component("card", Card);
    Vue.component("p-button", Button);
    Vue.component("modal-edit-box", ModalEditBox);
    Vue.component("modal-popup", ModalPopup);
    Vue.component("language-selector", LanguageSelector);
    Vue.component("localised-field-indicator", LocalisedFieldIndicator);
  }
};

export default GlobalComponents;
